import { useContext } from 'react';
import { CartContext } from 'src/contexts/CartProvider';

const useCart = () => {
  return useContext(CartContext);
};

export default useCart;
